/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import classNames from 'classnames/bind'
import { ROUTES } from 'constants/routes'
import { Text as TextType } from 'hocs/localization'
import { STEPS } from './constants'
import ChangePasswordForm from './apps/ChangePasswordForm'
import * as styles from './ChangePasswordCheckLink.scss'

const cx = classNames.bind(styles)

interface IProps extends RouteComponentProps {
  t: TextType,
  step: STEPS,
}

const ChangePasswordCheckLink: React.SFC<IProps> = ({
  step,
  location: { search },
  t,
}) => {
  if (step === STEPS.valid) {
    return (
      <React.Fragment>
        <ChangePasswordForm />
        <div className={cx('FormField', 'alreadyLogin')}>
          <Link to={ROUTES.home.logIn}>{t('backToLogin')}</Link>
        </div>
      </React.Fragment>
    )
  }
  if (step === STEPS.expired) {
    const link = <Link to={`${ROUTES.home.changePassword.new}${search}`}>{t('linkToNew')}</Link>
    return (
      <div className={styles.message}>
        {t('messageStart')} {link} {t('messageEnd')}
      </div>
    )
  }
}

export default ChangePasswordCheckLink
